import React from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "react-oidc-context";

/**
 * Guard component for public routes.
 * Redirects authenticated users away (unless forcePublicRoute).
 * Usage: <Route path="..." element={<PublicRoute forcePublicRoute><Page /></PublicRoute>} />
 */
const PublicRoute = ({ forcePublicRoute = false, children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated || forcePublicRoute) {
    return children;
  }

  return <Navigate to="/" state={{ from: location }} replace />;
};

export default PublicRoute;
